<div
  id="Add_query_modal"
  class="modal custom-modal fade"
  data-backdrop="static"
  role="dialog"
>
  <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="zero_country_form_title">Raise Query</h5>
        <!--  (click)="onCloseaddAppgroup()" -->
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <!-- <app-query></app-query> -->
      </div>
      <div class="modal-footer">
        <!-- (click)="onCloseaddAppgroup()" -->
        <button
          type="button"
          class="btn btn-danger btn-sm"
          data-dismiss="modal"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Header -->
<div class="header">
  <!-- Logo -->
  <div class="header-left d-xl-none d-lg-none">
    <a [routerLink]="['/dashboard']" class="logo">
      <img src="assets/img/logo.png" width="110" height="35" alt="" />
    </a>
  </div>

  <!-- /Logo -->
  <a
    id="toggle_btn"
    (click)="toggleSidebar()"
    href="javascript:void(0);"
    *ngIf="entity != 11"
  >
    <span class="bar-icon">
      <span></span>
      <span></span>
      <span></span>
    </span>
  </a>
  <!-- Header Title -->
  <div class="page-title-box d-lg-block cus-title1">
    <a [routerLink]="['/dashboard']" class="logo pt-2">
      <img src="assets/image/mobiliselogo-sparsh.png" width="120" alt="" />
    </a>
  </div>

  <!-- /Header Title -->
  <a id="mobile_btn" class="mobile_btn" href="#sidebar"
    ><i class="fa fa-bars"></i
  ></a>
  <!-- Header Menu -->
  <ul class="nav user-menu">
    <li (click)="goToVMS()">
      <div class="text-center" title="Atithi">
       <a class="btn btn-primary vmsBtn right-corder-container-button p-2 mt-3">
          <span class="text-light">Use Atithi App</span>
        </a>
      </div>
    </li>
    <li (click)="showApprovals()" *ngIf="empStatus == 1 && isPlacement!=true">
      <div class="text-center" title="Approvals">
        <a class="nav-link right-corder-container-button pt-15">
          <img src="assets/img/bell.svg" width="25" /><br />
          <!-- <i class="fa fa-bell" style="font-size: 30px;"></i> -->
          <span
            class="position-absolute text-light badgesetting badge rounded-pill"
          >
            <img src="assets/new_icon/pulse.gif" width="25" /><br />
            <!-- class="position-absolute text-light badgesetting badge rounded-pill bg-danger" -->
          </span>
          <span>Approvals</span>
        </a>
      </div>
    </li>
    <li *ngIf="empStatus == 1 && isPlacement!=true">
      <!-- <a class="nav-link right-corder-container-button pt-15" [routerLink]="['/dashboard/speakUp']"> -->
      <a
        class="nav-link right-corder-container-button pt-15"
        (click)="sosDisk()"
      >
        <div class="sos" title="sos">
          <img src="assets/img/quick/sos.png" width="30" height="30" />
        </div>
      </a>
    </li>
    <li *ngIf="empStatus==1 && isPlacement==false; else inactiveEmpQu;">
      <a
        class="nav-link right-corder-container-button pt-15"
        (click)="goToQuery('/queries/create')"
      >
        <!-- [routerLink]="['/queries/create']" -->
        <div class="sos" title="create query">
          <img src="assets/img/quick/query-icon1.png" width="25" height="25" />
        </div>
      </a>
    </li>
    <ng-template #inactiveEmpQu>
      <li *ngIf="isPlacement==false">
        <a
          class="nav-link right-corder-container-button pt-15" 
          (click)="goToQuery('/alumni/create')"
  
          >
          <!-- [routerLink]="['/queries/create']" -->
          <div class="sos" title="create query">
            <img src="assets/img/quick/query-icon1.png" width="25" height="25" />
          </div>
        </a>
      </li>
    </ng-template>

    <li *ngIf="empStatus == 1 && isPlacement!=true">
      <a
        class="nav-link right-corder-container-button pt-15"
        [routerLink]="['/covid19']"
      >
        <div class="sos" title="Covid19 help">
          <img src="assets/img/quick/covid19.png" width="25" height="25" />
        </div>
      </a>
    </li>
    <!-- <li class="nav-item dropdown">
            <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
                <i class="fa fa-bell-o"></i> <span class="badge badge-pill">3</span>
            </a>
            <div class="dropdown-menu notifications">
                <div class="topnav-dropdown-header">
                    <span class="notification-title">{{'Notifications' | translate}}</span>
                    <a href="javascript:void(0)" class="clear-noti"> {{'ClearAll' | translate}} </a>
                </div>
                <div class="noti-content">
                    <ul class="notification-list">
                        <li class="notification-message">
                            <a href="activities">
                                <div class="media">
                                    <span class="avatar">
                        <img alt="" src="assets/img/profiles/avatar-02.jpg">
                        </span>
                                    <div class="media-body">
                                        <p class="noti-details"><span class="noti-title">John Doe</span> added new task <span class="noti-title">Patient appointment booking</span></p>
                                        <p class="noti-time"><span class="notification-time">4 mins ago</span></p>
                                    </div>
                                </div>
                            </a>
                        </li>
                        <li class="notification-message">
                            <a href="activities">
                                <div class="media">
                                    <span class="avatar">
                        <img alt="" src="assets/img/profiles/avatar-03.jpg">
                        </span>
                                    <div class="media-body">
                                        <p class="noti-details"><span class="noti-title">Tarah Shropshire</span> changed the task name <span class="noti-title">Appointment booking with payment gateway</span></p>
                                        <p class="noti-time"><span class="notification-time">6 mins ago</span></p>
                                    </div>
                                </div>
                            </a>
                        </li>
                        <li class="notification-message">
                            <a href="activities">
                                <div class="media">
                                    <span class="avatar">
                        <img alt="" src="assets/img/profiles/avatar-06.jpg">
                        </span>
                                    <div class="media-body">
                                        <p class="noti-details"><span class="noti-title">Misty Tison</span> added <span class="noti-title">Domenic Houston</span> and <span class="noti-title">Claire Mapes</span> to project <span class="noti-title">Doctor available module</span></p>
                                        <p class="noti-time"><span class="notification-time">8 mins ago</span></p>
                                    </div>
                                </div>
                            </a>
                        </li>
                        <li class="notification-message">
                            <a href="activities">
                                <div class="media">
                                    <span class="avatar">
                        <img alt="" src="assets/img/profiles/avatar-17.jpg">
                        </span>
                                    <div class="media-body">
                                        <p class="noti-details"><span class="noti-title">Rolland Webber</span> completed task <span class="noti-title">Patient and Doctor video conferencing</span></p>
                                        <p class="noti-time"><span class="notification-time">12 mins ago</span></p>
                                    </div>
                                </div>
                            </a>
                        </li>
                        <li class="notification-message">
                            <a href="activities">
                                <div class="media">
                                    <span class="avatar">
                        <img alt="" src="assets/img/profiles/avatar-13.jpg">
                        </span>
                                    <div class="media-body">
                                        <p class="noti-details"><span class="noti-title">Bernardo Galaviz</span> added new task <span class="noti-title">Private chat module</span></p>
                                        <p class="noti-time"><span class="notification-time">2 days ago</span></p>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="topnav-dropdown-footer">
                    <a href="activities">{{'ViewallMessages' | translate}}</a>
                </div>
            </div>
        </li> -->
    <!-- Message Notifications -->
    <!-- <li class="nav-item dropdown mobilse-screen-menu">
            <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
                <i class="fa fa-comment-o"></i> <span class="badge badge-pill">8</span>
            </a>
            <div class="dropdown-menu notifications">
                <div class="topnav-dropdown-header">
                    <span class="notification-title">{{'Messages' | translate}}</span>
                    <a href="javascript:void(0)" class="clear-noti"> {{'ClearAll' | translate}} </a>
                </div>
                <div class="noti-content">
                    <ul class="notification-list">
                        <li class="notification-message">
                            <a href="chat">
                                <div class="list-item">
                                    <div class="list-left">
                                        <span class="avatar">
                           <img alt="" src="assets/img/profiles/avatar-09.jpg">
                           </span>
                                    </div>
                                    <div class="list-body">
                                        <span class="message-author">Richard Miles </span>
                                        <span class="message-time">12:28 AM</span>
                                        <div class="clearfix"></div>
                                        <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                                    </div>
                                </div>
                            </a>
                        </li>
                        <li class="notification-message">
                            <a href="chat">
                                <div class="list-item">
                                    <div class="list-left">
                                        <span class="avatar">
                           <img alt="" src="assets/img/profiles/avatar-02.jpg">
                           </span>
                                    </div>
                                    <div class="list-body">
                                        <span class="message-author">John Doe</span>
                                        <span class="message-time">6 Mar</span>
                                        <div class="clearfix"></div>
                                        <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                                    </div>
                                </div>
                            </a>
                        </li>
                        <li class="notification-message">
                            <a href="chat">
                                <div class="list-item">
                                    <div class="list-left">
                                        <span class="avatar">
                           <img alt="" src="assets/img/profiles/avatar-03.jpg">
                           </span>
                                    </div>
                                    <div class="list-body">
                                        <span class="message-author"> Tarah Shropshire </span>
                                        <span class="message-time">5 Mar</span>
                                        <div class="clearfix"></div>
                                        <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                                    </div>
                                </div>
                            </a>
                        </li>
                        <li class="notification-message">
                            <a href="chat">
                                <div class="list-item">
                                    <div class="list-left">
                                        <span class="avatar">
                           <img alt="" src="assets/img/profiles/avatar-05.jpg">
                           </span>
                                    </div>
                                    <div class="list-body">
                                        <span class="message-author">Mike Litorus</span>
                                        <span class="message-time">3 Mar</span>
                                        <div class="clearfix"></div>
                                        <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                                    </div>
                                </div>
                            </a>
                        </li>
                        <li class="notification-message">
                            <a href="chat">
                                <div class="list-item">
                                    <div class="list-left">
                                        <span class="avatar">
                           <img alt="" src="assets/img/profiles/avatar-08.jpg">
                           </span>
                                    </div>
                                    <div class="list-body">
                                        <span class="message-author"> Catherine Manseau </span>
                                        <span class="message-time">27 Feb</span>
                                        <div class="clearfix"></div>
                                        <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="topnav-dropdown-footer">
                    <a href="chat">{{'ViewallMessages' | translate}}</a>
                </div>
            </div>
        </li> -->
    <li
      *ngIf="(applications$ | async).length && empStatus=='1' "
      class="nav-item flag-nav"
      (click)="openAppSlide()"
    >
      <a class="nav-link" href="#" href="javascript:void(0);">
        <img src="assets/new_icon/applications.svg" alt="" height="25" />
        <!-- <span>{{ "Applications" | translate }}</span> -->
        <span></span>
      </a>
    </li>
    <li class="nav-item dropdown has-arrow flag-nav" *ngIf="allowLang">
      <!-- <select class="form">
        <option *ngFor="let data of languageList" [data.value]>{{data.label}}</option>
      </select> -->

      <a
        class="nav-link dropdown-toggle"
        data-toggle="dropdown"
        href="#"
        role="button"
      >
        <!-- <img src="assets/img/flags/us.png" alt="" height="20" /> -->
        <span>{{ crntLang }}</span>
      </a>
      <div class="dropdown-menu dropdown-menu-right">
        <a
          (click)="switchLang(lng)"
          class="dropdown-item"
          *ngFor="let lng of languageList"
        >
          <!-- <img src="assets/img/flags/us.png" alt="" height="16" /> -->
          {{ lng.label }}
        </a>
      </div>
    </li>
    <!-- /Flag -->
    <!-- /Message Notifications -->
    <li class="nav-item dropdown has-arrow main-drop">
      <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
        <span class="user-img">
          <img
            [src]="empImage"
            onError="src = 'assets/img/profile.webp'"
            width="36" />
          <span class="status online"></span
        ></span>
        <span>&nbsp;&nbsp;{{ userName }}</span>
      </a>
      <div class="dropdown-menu">
        <a
          class="dropdown-item"
          href="javascript:void(0);"
          (click)="clickMyProfile()"
          >{{ "MyProfile" | translate }}</a
        >
        <a
          class="dropdown-item"
          href="javascript:void(0);"
          [routerLink]="['auth/reset']"
          >Change Password</a
        >
        <!-- <a class="dropdown-item" href="javascript:void(0);">{{'Settings' | translate}}</a> -->
        <a
          class="dropdown-item"
          href="javascript:void(0);"
          (click)="logout()"
          >{{ "Logout" | translate }}</a
        >
      </div>
    </li>

    <li>
      <div class="logo" title="sos">
        <img src="assets/image/mobiliselogo.png" width="120" />
      </div>
    </li>
  </ul>
  <!-- /Header Menu -->

  <!-- Mobile Menu -->

  <div class="dropdown mobile-user-menu">
    <a
      href="#"
      class="nav-link dropdown-toggle"
      data-toggle="dropdown"
      aria-expanded="false"
      ><i class="fa fa-ellipsis-v"></i
    ></a>
    <div class="dropdown-menu dropdown-menu-right">
      <a
        class="dropdown-item"
        href="javascript:void(0);"
        (click)="clickMyProfile()"
        >{{ "MyProfile" | translate }}</a
      >
      <a
        class="dropdown-item"
        href="javascript:void(0);"
        [routerLink]="['auth/reset']"
        >Change Password</a
      >
      <!-- <a class="dropdown-item" href="javascript:void(0);">{{'Settings' | translate}}</a> -->
      <a class="dropdown-item" (click)="logout()">{{ "Logout" | translate }}</a>
    </div>
  </div>
  <!-- /Mobile Menu -->
</div>

<!-- <div
  class="appList container-fluid"
  style="
    background: url('assets/img/back/pattern1.png');
    background-size: 100% 100%;
  "
> -->
<!-- <div class="row row-replace add-m-b m-t-10">
    <div class="col-6 col-p h4">Applications</div>
    <div class="col-6 top-corner-items col-p">
      <button type="button" class="app-close" (click)="applicationBack1()">
        <span>×</span>
      </button>
    </div>
  </div>
  <section class="row">
    <div class="container">
      <div class="row">
        <div
          class="col-md-2 col-4 app-col text-center ancor"
          *ngFor="let apps of applications$ | async"
          (click)="goToApplication(apps.app_link,apps)"
        >
          <section class="bg-change shadow m-t-16 main-menu">
            <div>
              <img
                [src]="public + '/uploads/application_files/' + apps.icon"
                class="make-link img-opcity"
                alt=""
                height="50"
              />

              <h4 class="text-white">{{ apps.app_desc }}</h4>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</div> -->

<div
  class="modal custom-modal fade"
  id="sos-help-disk"
  role="dialog"
  style="display: none"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Welcome SOS Service</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="sosForm" (ngSubmit)="submitSos()">
          <p>
            Thanks! for using SOS Service. On clicking this button an sms will
            be sent to regional HR and A ticket will be generated. Please click
            on Submit to continue or cancel to reject!
          </p>
          <div class="form-group">
            <label>Mobile <span class="text-danger">*</span></label>
            <div>
              <input
                class="form-control"
                formControlName="sos_contact_no"
                placeholder="Enter Your Mobile Number"
                type="number"
              />
            </div>
            <div
              *ngIf="submit && sosErrorMsg.sos_contact_no.errors"
              class="form-error"
            >
              <div *ngIf="sosErrorMsg.sos_contact_no.errors.required">
                Contact Number is required !
              </div>
            </div>
          </div>
          <div class="submit-section">
            <button class="btn btn-primary btn-sm">Submit</button>
            <button
              class="btn btn-danger btn-sm m-l-15"
              data-dismiss="modal"
              (click)="reset()"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- new side bar code-->

<div class="appList container-fluid">
  <section class="row">
    <div class="col-12 col-pn" style="margin-bottom: 60px">
      <ul class="list-group custom-sidebar">
        <li>
          <div class="row">
            <div class="col-10 col-pn">
              <i class="fa fa-th"></i> Applications
            </div>
            <div class="col-2 col-pn">
              <i class="fa fa-times app-close" (click)="applicationBack1()"></i>
            </div>
          </div>
        </li>

        <li
          *ngFor="let apps of applications$ | async"
          (click)="goToApplication(apps.app_link, apps)"
        >
          <div class="row align-items-center">
            <div class="col-2 col-pn">
              <img
                [src]="apps.icon"
                class="make-link img-opcity"
                alt=""
                height="30"
              />
            </div>
            <div class="col-10 col-pn">
              <span>{{ apps.app_desc }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </section>
</div>
